import { DefinedDefaults, TWithDataComponent } from "@/ui/lib";
import { PropsWithChildren } from "react";
import { TIconKey } from "../../primitives";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const HEADED_SECTION_HEADER_THEME_CLASS_MAP = {
  default: "bg-component-headed-section-header-default text-foreground-inverse",
  simple: "bg-component-headed-section-header-simple",
  content: "bg-component-headed-section-header-content",
  scoop: "bg-component-headed-section-header-scoop",
  fresh: "bg-component-headed-section-header-fresh",
  elevated: "bg-component-headed-section-header-elevated",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type THeadedSectionTheme = keyof typeof HEADED_SECTION_HEADER_THEME_CLASS_MAP;

export type THeadedSectionIconProps = {
  icon?: TIconKey;
};

export type THeadedSectionHeaderProps = {
  title: string;
  theme: THeadedSectionTheme;
} & THeadedSectionIconProps;

export type THeadedSectionContentProps = {
} & PropsWithChildren;

export type THeadedSectionProps = THeadedSectionHeaderProps &
  THeadedSectionContentProps &
  TWithDataComponent & {
  };

type THeadedSectionDefaultProps = DefinedDefaults<
  THeadedSectionProps,
  "theme" | "data-component"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const HEADED_SECTION_DEFAULTS = {
  theme: "default",
  "data-component": "HeadedSection",
} satisfies THeadedSectionDefaultProps;
